import { createSelector } from 'reselect'

export const getPageMetaTagsSingle = createSelector(
  (state) => state && state.common && state.common.pageMetaTagsSingle ? state.common.pageMetaTagsSingle : null,
  (pageMetaTagsSingle) => pageMetaTagsSingle
)
